import ActionExportReport from '../CardToolbarActions/ActionExportReport';
import ActionSaveReport from '../CardToolbarActions/ActionSaveReport';
import ActionCustomizeReport from '../CardToolbarActions/ActionCustomizeReport';
import { REPORT_ACTIONS } from '../constants/ReportCardOptions';
export const ACTION_COMPONENTS = {
  [REPORT_ACTIONS.SAVE_REPORT]: ActionSaveReport,
  [REPORT_ACTIONS.EXPORT_REPORT]: ActionExportReport,
  [REPORT_ACTIONS.CUSTOMIZE_REPORT]: ActionCustomizeReport
};